import React from 'react'

export default function UserCheck() {
  return (
    <div className="flex min-h-[50vh] items-center justify-center">
      <p className="text-sm font-medium tracking-wide text-mauve-600">
        Loading user data
      </p>
    </div>
  )
}
